import { CToast, CToastBody, CToastHeader, CToaster } from '@coreui/react-pro'
import React, { createContext, useContext, useRef, useState } from 'react'

const ToastContext = createContext({})

const ToastsProvider = ({ children }) => {
  const [toast, setToast] = useState(0)
  const toaster = useRef()

  const getColorAndTitle = (payload) => {
    const SUCCESS = '#51cc8a'
    const DANGER = '#ef376e'
    const WARNING = '#fc0'
    const INFO = '#325bed'
    const { type } = payload
    switch (type) {
      case 'warning':
        return {
          color: WARNING,
          title: 'Aviso',
        }
      case 'error':
        return {
          color: DANGER,
          title: 'Erro',
        }
      case 'info':
        return {
          color: INFO,
          title: 'Informação',
        }
      default:
        return {
          color: SUCCESS,
          title: 'Sucesso',
        }
    }
  }

  const exampleToast = (payload) => {
    const { color, title } = getColorAndTitle(payload)
    const { message } = payload
    return (
      <CToast>
        <CToastHeader closeButton>
          <svg className="rounded me-2" width="20" height="20" focusable="false" role="img">
            <rect width="100%" height="100%" fill={color}></rect>
          </svg>
          <div className="fw-bold me-auto">{title}</div>
        </CToastHeader>
        <CToastBody>{message || ''}</CToastBody>
      </CToast>
    )
  }

  const addToast = (payload) => {
    setToast(exampleToast(payload))
  }

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <CToaster ref={toaster} push={toast} placement="top-end" />
    </ToastContext.Provider>
  )
}

const useToasts = () => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToasts must be used within an ToastsProvider')
  }
  return context
}

export { ToastsProvider, useToasts }
